/**
 * The market and the run of the screen the person is on, from the address the router already
 * parsed — what «Attach the run I am looking at» and the report's market start from (ADR 9071).
 *
 * Pure over the router's parameters, so the test asserts on an object and not on `window`. The
 * address's keys are the chapters' own: a market is `market` or `country`, a run is `runId`, or an
 * exit run's `exitRunId` / `exitLaneRunId`. Nothing is defaulted: a screen with none attaches none.
 * The run ids leave the browser only in the person's own report (`affected_runs`) or in a filing's
 * context — never in a question to OPTIMA.
 */

const MARKET_KEYS = ['market', 'country'] as const;
const RUN_KEYS = ['runId', 'exitRunId', 'exitLaneRunId'] as const;

export interface ScreenScope {
  readonly markets: readonly string[];
  readonly runs: readonly string[];
}

const NONE: ScreenScope = { markets: [], runs: [] };

function values(params: Readonly<Record<string, string>>, keys: readonly string[]): readonly string[] {
  const out: string[] = [];
  for (const key of keys) {
    const value = Object.hasOwn(params, key) ? params[key]?.trim() ?? '' : '';
    if (value !== '' && !out.includes(value)) out.push(value);
  }
  return out;
}

export function screenScope(params: Readonly<Record<string, string>> | undefined): ScreenScope {
  if (params === undefined) return NONE;
  return { markets: values(params, MARKET_KEYS).map((market) => market.toUpperCase()), runs: values(params, RUN_KEYS) };
}
